import { useSession } from '~/contexts/SessionContext';
import { DomainStore } from '~/domain/changes/DomainStore';

export function useDomainStore(): DomainStore {
    return useSession().context.store;
}
